import React, { useState } from "react";
import { Share2, Copy, Check, Loader2 } from "lucide-react";

// Creator's "send the link" box while waiting for a mate.
export const ShareLinkBox = ({ link, stake, onCancel }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
    } catch (e) { /* clipboard blocked */ }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };
  const share = async () => {
    const text = stake ? `Penalty shootout for £${stake} (virtual). Think you can beat my keeper? Tap to play:` : "Free penalty shootout. Think you can beat my keeper? Tap to play:";
    if (navigator.share) {
      try {
        await navigator.share({ title: "Footie Clash penalties", text, url: link });
        return;
      } catch (e) {
        if (e?.name === "AbortError") return;
      }
    }
    copy();
  };
  return (
    <div data-testid="shootout-share-box" className="card-38 p-5 hover:translate-y-0 max-w-md mx-auto text-center">
      <h2 className="font-display font-extrabold text-2xl text-white">Your shootout is ready</h2>
      <p className="text-slate-400 text-sm mt-1">Send it to a mate. When they tap it you both go straight to the spin.</p>
      <button data-testid="shootout-share-btn" onClick={share} className="btn-green wager-glow w-full rounded-xl py-4 mt-5 font-extrabold text-lg flex items-center justify-center gap-2">
        <Share2 className="w-5 h-5" /> Send link to your mate
      </button>
      <button data-testid="shootout-copy-btn" onClick={copy} className="mt-2 w-full rounded-xl border border-white/10 bg-black/25 px-3 py-2.5 flex items-center gap-2 text-left hover:border-[#38BDF8]/40 transition-colors">
        <span data-testid="shootout-link-text" className="flex-1 min-w-0 truncate text-xs text-slate-300">{link.replace(/^https?:\/\//, "")}</span>
        <span className="text-xs font-semibold text-[#38BDF8] flex items-center gap-1 shrink-0">
          {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
          {copied ? "Copied" : "Copy"}
        </span>
      </button>
      <div className="mt-4 flex items-center justify-center gap-2 text-slate-400 text-sm">
        <Loader2 className="w-4 h-4 animate-spin" /> Waiting for your mate…
      </div>
      <button data-testid="shootout-cancel-btn" onClick={onCancel} className="mt-3 text-xs text-slate-500 hover:text-white underline">
        Cancel & refund £{stake}
      </button>
    </div>
  );
};

export default ShareLinkBox;
